export default {
  placeholder: 'Wybierz poziom aktywów',
};
